import React, { useState } from "react";
import { MapPin } from "lucide-react";
import CoverBlock from "../../../components/CoverBlock";
import { FD_FEED_VOTE_CTA, FD_VOTE_SKIP } from "../copy.js";
import { ReadableCard, ReadableNavButton } from "../../../components/Sticker";

function fmtOccurrence(iso) {
  try {
    return new Date(iso).toLocaleString("en-GB", {
      weekday: "short",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export default function FavoriteDancesVoteCard({ item, onVote, onSkip }) {
  const ev = item.event;
  const [voting, setVoting] = useState(false);
  const [skipping, setSkipping] = useState(false);
  const busy = voting || skipping;

  async function handleVote() {
    if (busy) return;
    setVoting(true);
    try {
      await onVote?.();
    } finally {
      setVoting(false);
    }
  }

  async function handleSkip() {
    if (busy) return;
    setSkipping(true);
    try {
      await onSkip?.();
    } finally {
      setSkipping(false);
    }
  }

  const locationLine = [ev.location, ev.city].filter(Boolean).join(", ");

  return (
    <ReadableCard
      className="p-0 overflow-hidden"
      data-testid={`favorite-dances-vote-card-${item.id}`}
      aria-busy={busy || undefined}
    >
      <CoverBlock coverColor={ev.cover_color} className="border-b border-black/[0.08] p-4">
        <p className="font-ui font-medium text-[13px] tabular-nums text-ink/65">
          {fmtOccurrence(item.occurrence_at)}
        </p>
        <h3 className="font-display font-semibold text-[20px] leading-tight mt-0.5 text-balance break-words">
          {ev.name}
        </h3>
        {locationLine && (
          <p className="mt-2 text-[13px] font-ui font-medium text-ink/75 inline-flex items-center gap-1">
            <MapPin className="w-3.5 h-3.5 shrink-0" strokeWidth={2.5} aria-hidden />
            {locationLine}
          </p>
        )}
      </CoverBlock>
      <div className="bg-white p-4">
        <div className="flex flex-wrap items-center gap-2">
          <span
            className="inline-flex min-h-[44px] items-center rounded-btn border border-black/[0.08] bg-canvas px-3 font-ui text-[13px] font-semibold text-ink/70"
            data-testid={`favorite-dances-checked-out-${item.id}`}
          >
            Checked out
          </span>
          <ReadableNavButton
            type="button"
            variant="primary"
            className="min-h-[44px] px-4 text-[14px]"
            disabled={busy}
            onClick={handleVote}
            data-testid={`favorite-dances-vote-open-${item.id}`}
          >
            {voting ? "Opening…" : FD_FEED_VOTE_CTA}
          </ReadableNavButton>
          <ReadableNavButton
            type="button"
            variant="default"
            className="min-h-[44px] px-4 text-[14px]"
            disabled={busy}
            onClick={handleSkip}
            data-testid={`favorite-dances-vote-skip-${item.id}`}
          >
            {skipping ? "Skipping…" : FD_VOTE_SKIP}
          </ReadableNavButton>
        </div>
      </div>
    </ReadableCard>
  );
}
